const id_supplychain_itemReq = {
    add: "tambah permintaan barang",
    edit: "ubah permintaan barang",
    detail: "detail permintaan barang",

    label: {
        date_target: "Tanggal Target Dikirim",
        up_img: "Unggah Gambar",
        btn_po: "buat PO",
        btn_so: "buat SO",
        btn_do: "buat DO",
        goods_id: "ID Barang",

        view_title: "SURAT PERMINTAAN BARANG",
    },

    error: {
        create: "Gagal membuat permintaan barang",
        detail_data: "Data barang tidak boleh kosong",
        detail_min: "Minimal terdapat 1 barang",
        detail_up: "Tunggu sampai proses mengunggah file selesai",
        img_up: "Gagal mengunggah gambar",
        img_up_size: "Ukuran file tidak boleh lebih dari 16Mb",
        edit: "Gagal mengubah permintaan barang",
    },

    success: {
        create: "Berhasil membuat permintaan barang",
        edit: "Berhasil mengubah permintaan barang",
    },

    message: {
        conf_finish_title: "Apakah Anda yakin untuk menyelesaikan permintaan?",
        conf_finish_text: "Masukan alasan menyelesaikan permintaan",

        reject_title: "Apakah Anda yakin untuk membatalkan permintaan?",
        reject_text: "Masukan alasan membatalkan permintaan",
    },
}

export default id_supplychain_itemReq;